import commonApi from '../../actions/common';
import handleApiCall from '../../handleApiCall';
import CallError from '../../utils/CallError';
import { settings } from './setup';

/**
 * featured products
 */
export default async (params = {}, signal = null) => {
  const { authToken } = params;
  const handler = handleApiCall(commonApi.staticData, {
    slice: 'hostApps',
  });

  const staticHostApps = Array.from(await handler.run());
  const headers = new Headers({
    'x-api-key': settings.apiKey,
    Accept: 'application/vnd.adobe.xt.app-card-v1+json',
  });

  if (authToken) {
    headers.append('Authorization', authToken);
  }

  const response = await fetch(`${settings.endpoint}/v2/apps?hostApp=All&pageIndex=0&pageSize=1&type=EC`, {
    signal,
    headers,
  });
  let content = await response.text();

  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content.filters
      .filter((f) => f.type === 'hostApp')
      .sort((a, b) => b.count - a.count)
      .splice(0, 3)
      .map((product) => {
        const staticProduct = staticHostApps
          .filter(([key, _value]) => key === product?.name)
          .map(([key, value]) => ({ key, ...value }))
          .pop();
        return { ...staticProduct, ...product };
      });
  }
};
